const customerDuplicateDocumentUserMessage = [
    {
        language: 'DEFAULT',
        message: 'Este CPF/CNPJ já está cadastrado. Verifique os dados informados.',
    },
    {
        language: 'en-US',
        message: 'This CPF/CNPJ is already registered. Please check the provided data.',
    },
    {
        language: 'es-ES',
        message: 'Este CPF/CNPJ ya está registrado. Verifique los datos proporcionados.',
    },
    {
        language: 'pt-BR',
        message: 'Este CPF/CNPJ já está cadastrado. Verifique os dados informados.',
    },
];
export const customerErrorMappings = {
    CUSTOMER_VALIDATION_NAME_TOO_LONG: {
        code: 'CUSTOMER_VALIDATION_NAME_TOO_LONG',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O nome do cliente é muito longo. Use no máximo 50 caracteres.',
            },
            {
                language: 'en-US',
                message: 'Customer name is too long. Use a maximum of 50 characters.',
            },
            {
                language: 'es-ES',
                message: 'El nombre del cliente es demasiado largo. Use un máximo de 50 caracteres.',
            },
            {
                language: 'pt-BR',
                message: 'O nome do cliente é muito longo. Use no máximo 50 caracteres.',
            },
        ],
        technicalMessage: 'A quantidade de caracteres de Nome deve ser menor ou igual',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_DUPLICATE_DOCUMENT: {
        code: 'CUSTOMER_DUPLICATE_DOCUMENT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: customerDuplicateDocumentUserMessage,
        technicalMessage: 'CPF/CNPJ já cadastrado',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_CPF_CNPJ_ALREADY_EXISTS: {
        code: 'CUSTOMER_CPF_CNPJ_ALREADY_EXISTS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: customerDuplicateDocumentUserMessage,
        technicalMessage: 'CPF/CNPJ already exists',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_VALIDATION_ADDRESS_NUMBER_INVALID: {
        code: 'CUSTOMER_VALIDATION_ADDRESS_NUMBER_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O número do endereço deve ser um número válido.',
            },
            {
                language: 'en-US',
                message: 'The address number must be a valid number.',
            },
            {
                language: 'es-ES',
                message: 'El número de dirección debe ser un número válido.',
            },
            {
                language: 'pt-BR',
                message: 'O número do endereço deve ser um número válido.',
            },
        ],
        technicalMessage: 'address.number" deve ser um número',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_VALIDATION_EMAIL_INVALID: {
        code: 'CUSTOMER_VALIDATION_EMAIL_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O e-mail informado é inválido. Verifique o formato.',
            },
            {
                language: 'en-US',
                message: 'The provided email is invalid. Please check the format.',
            },
            {
                language: 'es-ES',
                message: 'El correo electrónico proporcionado es inválido. Verifique el formato.',
            },
            {
                language: 'pt-BR',
                message: 'O e-mail informado é inválido. Verifique o formato.',
            },
        ],
        technicalMessage: 'Email deve ser um e-mail válido',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_EMAIL_MAX_LIMIT_EXCEEDED: {
        code: 'CUSTOMER_EMAIL_MAX_LIMIT_EXCEEDED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O cliente já possui o limite máximo de 3 e-mails cadastrados.',
            },
            {
                language: 'en-US',
                message: 'The client has already reached the maximum limit of 3 registered email addresses.',
            },
            {
                language: 'es-ES',
                message: 'El cliente ya alcanzó el límite máximo de 3 correos electrónicos registrados.',
            },
            {
                language: 'pt-BR',
                message: 'O cliente já possui o limite máximo de 3 e-mails cadastrados.',
            },
        ],
        technicalMessage: 'Customer email max limit exceeded',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_EMAIL_REQUIRED: {
        code: 'CUSTOMER_EMAIL_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Informe ao menos um e-mail para o cliente.',
            },
            {
                language: 'en-US',
                message: 'Enter at least one email for the client.',
            },
            {
                language: 'es-ES',
                message: 'Ingrese al menos un correo electrónico para el cliente.',
            },
            {
                language: 'pt-BR',
                message: 'Informe ao menos um e-mail para o cliente.',
            },
        ],
        technicalMessage: 'Customer email is required',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_EMAIL_INVALID_FORMAT: {
        code: 'CUSTOMER_EMAIL_INVALID_FORMAT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O e-mail informado é inválido. Verifique o formato.',
            },
            {
                language: 'en-US',
                message: 'The provided email is invalid. Please check the format.',
            },
            {
                language: 'es-ES',
                message: 'El correo electrónico proporcionado es inválido. Verifique el formato.',
            },
            {
                language: 'pt-BR',
                message: 'O e-mail informado é inválido. Verifique o formato.',
            },
        ],
        technicalMessage: 'Customer email format is invalid',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_EMAIL_DUPLICATE: {
        code: 'CUSTOMER_EMAIL_DUPLICATE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'E-mails duplicados não são permitidos.',
            },
            {
                language: 'en-US',
                message: 'Duplicate emails are not allowed.',
            },
            {
                language: 'es-ES',
                message: 'No se permiten correos electrónicos duplicados.',
            },
            {
                language: 'pt-BR',
                message: 'E-mails duplicados não são permitidos.',
            },
        ],
        technicalMessage: 'Customer email contains duplicate values',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_COMMUNICATION_REQUIRED: {
        code: 'CUSTOMER_COMMUNICATION_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Para envio de comunicação, informe o telefone para o cliente.',
            },
            {
                language: 'en-US',
                message: 'To send communication, enter the client phone number.',
            },
            {
                language: 'es-ES',
                message: 'Para enviar comunicación, ingrese el teléfono del cliente.',
            },
            {
                language: 'pt-BR',
                message: 'Para envio de comunicação, informe o telefone para o cliente.',
            },
        ],
        technicalMessage: 'Customer communication requires phone',
        severity: 'warning',
        critical: false,
    },
    CUSTOMER_VALIDATION_DOCUMENT_INVALID: {
        code: 'CUSTOMER_VALIDATION_DOCUMENT_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CPF ou CNPJ inválido. Verifique os dados informados.',
            },
            {
                language: 'en-US',
                message: 'Invalid CPF or CNPJ. Please check the provided data.',
            },
            {
                language: 'es-ES',
                message: 'CPF o CNPJ inválido. Verifique los datos proporcionados.',
            },
            {
                language: 'pt-BR',
                message: 'CPF ou CNPJ inválido. Verifique os dados informados.',
            },
        ],
        technicalMessage: 'CPF ou CNPJ do Cliente inválido',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_VALIDATION_NEIGHBORHOOD_LENGTH: {
        code: 'CUSTOMER_VALIDATION_NEIGHBORHOOD_LENGTH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O bairro deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'pt-BR',
                message: 'O bairro deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'en-US',
                message: 'The neighborhood must be between 3 and 100 characters.',
            },
            {
                language: 'es-ES',
                message: 'El barrio debe tener entre 3 y 100 caracteres.',
            },
        ],
        technicalMessage: 'Bairro do cliente deve ter entre 3 e 100 caracteres',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_VALIDATION_PAYER_NAME_INVALID: {
        code: 'CUSTOMER_VALIDATION_PAYER_NAME_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O nome do pagador não deve conter caracteres especiais.',
            },
            {
                language: 'pt-BR',
                message: 'O nome do pagador não deve conter caracteres especiais.',
            },
            {
                language: 'en-US',
                message: 'The payer name must not contain special characters.',
            },
            {
                language: 'es-ES',
                message: 'El nombre del pagador no debe contener caracteres especiales.',
            },
        ],
        technicalMessage: 'Nome do pagador não deve conter caracteres especiais',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_VALIDATION_ADDRESS_COMPLEMENT_LENGTH: {
        code: 'CUSTOMER_VALIDATION_ADDRESS_COMPLEMENT_LENGTH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O complemento do endereço deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'pt-BR',
                message: 'O complemento do endereço deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'en-US',
                message: 'The address complement must be between 3 and 100 characters.',
            },
            {
                language: 'es-ES',
                message: 'El complemento de dirección debe tener entre 3 y 100 caracteres.',
            },
        ],
        technicalMessage: 'debitor.address.complement deve ter de 3 a 100 caracteres',
        severity: 'error',
        critical: false,
    },
    CUSTOMER_VALIDATION_PAYER_COMPLEMENT_LENGTH: {
        code: 'CUSTOMER_VALIDATION_PAYER_COMPLEMENT_LENGTH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O complemento do pagador deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'pt-BR',
                message: 'O complemento do pagador deve ter entre 3 e 100 caracteres.',
            },
            {
                language: 'en-US',
                message: 'The payer complement must be between 3 and 100 characters.',
            },
            {
                language: 'es-ES',
                message: 'El complemento del pagador debe tener entre 3 y 100 caracteres.',
            },
        ],
        technicalMessage: 'Complemento do pagador deve ter entre 3 e 100 caracteres',
        severity: 'error',
        critical: false,
    },
};
